import React, { useMemo, useState, useEffect } from "react";
import "./CycleOverview.css";
import { useTranslation, Trans } from "react-i18next";

// ✅ Import des hooks
import useAuthSession from "../../../../authPatient/hooks/useAuthSession";
import { useUserCycle } from "@/cycle/hooks/useUserCycle";

/* =========================
   Timeline Icons
========================= */
const TimelineIcon = ({ type }) => {
  if (type === "period") {
    return (
      <span className="cyc-ico cyc-ico--period" aria-hidden>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <g opacity="0.9">
            <path
              d="M12 22C13.8565 22 15.637 21.2625 16.9497 19.9497C18.2625 18.637 19 16.8565 19 15C19 13 18 11.1 16 9.5C14 7.9 12.5 5.5 12 3C11.5 5.5 10 7.9 8 9.5C6 11.1 5 13 5 15C5 16.8565 5.7375 18.637 7.05025 19.9497C8.36301 21.2625 10.1435 22 12 22Z"
              stroke="#EC4899"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </svg>
      </span>
    );
  }

  if (type === "fertility") {
    return (
      <span className="cyc-ico cyc-ico--fert" aria-hidden>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <g opacity="0.9">
            <path
              d="M12 2C8 2 4 8 4 14C4 16.1217 4.84285 18.1566 6.34315 19.6569C7.84344 21.1571 9.87827 22 12 22C14.1217 22 16.1566 21.1571 17.6569 19.6569C19.1571 18.1566 20 16.1217 20 14C20 8 16 2 12 2Z"
              stroke="#EC4899"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </svg>
      </span>
    );
  }

  // PMS
  return (
    <span className="cyc-ico cyc-ico--pms" aria-hidden>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g opacity="0.9">
          <path
            d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
            stroke="#EC4899"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 16.5C12 17.39 11.7361 18.26 11.2416 19.0001C10.7471 19.7401 10.0443 20.3169 9.22208 20.6575C8.39981 20.9981 7.49501 21.0872 6.6221 20.9135C5.74918 20.7399 4.94736 20.3113 4.31802 19.682C3.68868 19.0526 3.2601 18.2508 3.08647 17.3779C2.91283 16.505 3.00195 15.6002 3.34254 14.7779C3.68314 13.9557 4.25991 13.2529 4.99994 12.7584C5.73996 12.2639 6.60999 12 7.5 12C6.60999 12 5.73996 11.7361 4.99994 11.2416C4.25991 10.7471 3.68314 10.0443 3.34254 9.22208C3.00195 8.39981 2.91283 7.49501 3.08647 6.6221C3.2601 5.74918 3.68868 4.94736 4.31802 4.31802C4.94736 3.68868 5.74918 3.2601 6.6221 3.08647C7.49501 2.91283 8.39981 3.00195 9.22208 3.34254C10.0443 3.68314 10.7471 4.25991 11.2416 4.99994C11.7361 5.73996 12 6.60999 12 7.5C12 6.60999 12.2639 5.73996 12.7584 4.99994C13.2529 4.25991 13.9557 3.68314 14.7779 3.34254C15.6002 3.00195 16.505 2.91283 17.3779 3.08647C18.2508 3.2601 19.0526 3.68868 19.682 4.31802C20.3113 4.94736 20.7399 5.74918 20.9135 6.6221C21.0872 7.49501 20.9981 8.39981 20.6575 9.22208C20.3169 10.0443 19.7401 10.7471 19.0001 11.2416C18.26 11.7361 17.39 12 16.5 12C17.39 12 18.26 12.2639 19.0001 12.7584C19.7401 13.2529 20.3169 13.9557 20.6575 14.7779C20.9981 15.6002 21.0872 16.505 20.9135 17.3779C20.7399 18.2508 20.3113 19.0526 19.682 19.682C19.0526 20.3113 18.2508 20.7399 17.3779 20.9135C16.505 21.0872 15.6002 20.9981 14.7779 20.6575C13.9557 20.3169 13.2529 19.7401 12.7584 19.0001C12.2639 18.26 12 17.39 12 16.5Z"
            stroke="#EC4899"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M12 7.5V9" stroke="#EC4899" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M7.5 12H9" stroke="#EC4899" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M16.5 12H15" stroke="#EC4899" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M12 16.5V15" stroke="#EC4899" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M8 8L9.88 9.88" stroke="#EC4899" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M14.1201 9.88L16.0001 8" stroke="#EC4899" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M8 15.9991L9.88 14.1191" stroke="#EC4899" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M14.1201 14.1191L16.0001 15.9991" stroke="#EC4899" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        </g>
      </svg>
    </span>
  );
};

/* =========================
   SMOOTH AREA CHART
========================= */
function MiniSmoothAreaChart({ values = [], months = [], cycles = [] }) {
  const { t } = useTranslation("cycle");

  const { dLine, dArea, yTicks, xTicks, pointsData } = useMemo(() => {
    const W = 760;
    const H = 340;

    const padL = 86;
    const padR = 26;
    const padT = 18;
    const padB = 58;

    const x0 = padL;
    const x1 = W - padR;
    const y0 = padT;
    const y1 = H - padB;

    const ticks = [40, 30, 25, 18.5, 15];

    const vmin = 15;
    const vmax = 40;
    const span = vmax - vmin;

    const stepX = (x1 - x0) / Math.max(1, values.length - 1);

    const pts = values.map((v, i) => {
      const x = x0 + i * stepX;
      const y = y0 + (y1 - y0) * (1 - (v - vmin) / span);
      
      // Déterminer si le cycle est anormal (< 21 ou > 35 jours)
        const isAbnormal = v < 21 || v > 35;
        return { x, y, v, isAbnormal };
    });

    const smoothPath = (p) => {
      if (p.length < 2) return "";
      const d = [`M ${p[0].x.toFixed(2)} ${p[0].y.toFixed(2)}`];

      for (let i = 0; i < p.length - 1; i++) {
        const p0 = p[i - 1] || p[i];
        const p1 = p[i];
        const p2 = p[i + 1];
        const p3 = p[i + 2] || p2;

        const c1x = p1.x + (p2.x - p0.x) / 6;
        const c1y = p1.y + (p2.y - p0.y) / 6;
        const c2x = p2.x - (p3.x - p1.x) / 6;
        const c2y = p2.y - (p3.y - p1.y) / 6;

        d.push(
          `C ${c1x.toFixed(2)} ${c1y.toFixed(2)}, ${c2x.toFixed(2)} ${c2y.toFixed(2)}, ${p2.x.toFixed(2)} ${p2.y.toFixed(2)}`
        );
      }
      return d.join(" ");
    };

    const dLine = smoothPath(pts);
    const dArea = `${dLine} L ${pts[pts.length - 1].x.toFixed(2)} ${y1.toFixed(2)} L ${pts[0].x.toFixed(2)} ${y1.toFixed(2)} Z`;

    const yTicks = ticks.map((tv) => {
      const y = y0 + (y1 - y0) * (1 - (tv - vmin) / span);
      return { v: tv, y };
    });

    const xTicks = months.map((m, i) => ({
      label: m,
      x: x0 + i * ((x1 - x0) / Math.max(1, months.length - 1)),
    }));

    return { dLine, dArea, yTicks, xTicks, pointsData: pts };
  }, [values, months]);

  return (
    <div className="cyc-smooth">
      <svg viewBox="0 0 760 340" className="cyc-smooth__svg" role="img" aria-label={t("cycle.chartAriaLabel")}>
        <defs>
          <linearGradient id="cycPinkFill" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#FF77B8" stopOpacity="0.55" />
            <stop offset="55%" stopColor="#FF77B8" stopOpacity="0.18" />
            <stop offset="100%" stopColor="#FF77B8" stopOpacity="0.0" />
          </linearGradient>
        </defs>

        <g className="cyc-smooth__grid">
          {yTicks.map((tt) => (
            <g key={tt.v}>
              <line x1="86" y1={tt.y} x2="734" y2={tt.y} />
              <text x="56" y={tt.y + 5} textAnchor="end">
                {tt.v}
              </text>
            </g>
          ))}
        </g>

        <path d={dArea} className="cyc-smooth__area" fill="url(#cycPinkFill)" />
        <path d={dLine} className="cyc-smooth__line" />

        {/* ✅ Points colorés selon normalité */}
        {pointsData.map((pt, i) => (
          <circle
            key={i}
            cx={pt.x}
            cy={pt.y}
            r="4"
            fill={pt.isAbnormal ? "#EF4444" : "#10B981"}
            stroke="#fff"
            strokeWidth="2"
          >
            <title>{`${pt.v} jours ${pt.isAbnormal ? '(anormal)' : '(normal)'}`}</title>
          </circle>
        ))}

        <g className="cyc-smooth__months">
          {xTicks.map((tt) => (
            <text key={tt.label} x={tt.x} y="324" textAnchor="middle">
              {tt.label}
            </text>
          ))}
        </g>
      </svg>
    </div>
  );
}

export default function CycleOverview() {
  const { t, i18n } = useTranslation("cycle");
  const [showInitialLoader, setShowInitialLoader] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShowInitialLoader(false), 2200);
    return () => clearTimeout(timer);
  }, []);

  // ✅ Récupération de l'utilisateur connecté
  const { effectiveUserId } = useAuthSession({ auto: true, once: true });
  const userId = effectiveUserId;

  // ✅ Chargement des données du cycle depuis le backend
  const { 
    cycles, 
    predictions,
    fertilityWindow,
    summary, 
    isLoading, 
    error,
    reloadAll,
  } = useUserCycle(userId, {
    autoFetch: true,
    withSummary: true,
    // Defer predictions/fertility fetch until we have cycles
    withPredictions: false,
    withFertilityWindow: false,
  });

  // Load predictions/fertility only once when cycles are present
  const [predictionsLoaded, setPredictionsLoaded] = useState(false);
  useEffect(() => {
    if (predictionsLoaded) return;
    if (cycles && cycles.length > 0) {
      if (typeof reloadAll === "function") reloadAll();
      setPredictionsLoaded(true);
    }
  }, [cycles, predictionsLoaded, reloadAll]);

  const lang = i18n.language || "en";
  const locale = lang.startsWith("ar") ? "ar" : lang;

  // ✅ Calcul des jours restants jusqu'à la prochaine période
  const { periodInDays, ovulationInDays } = useMemo(() => {
    if (!predictions || predictions.length === 0) {
      return { periodInDays: null, ovulationInDays: null };
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Prochain cycle prédit
    const nextPrediction = predictions[0];
    if (!nextPrediction) return { periodInDays: 0, ovulationInDays: 0 };

    const periodStart = new Date(nextPrediction.predictedStartDate);
    periodStart.setHours(0, 0, 0, 0);

    const ovulationDate = new Date(nextPrediction.ovulationDate);
    ovulationDate.setHours(0, 0, 0, 0);

    const periodDiff = Math.ceil((periodStart - today) / (1000 * 60 * 60 * 24));
    const ovulationDiff = Math.ceil((ovulationDate - today) / (1000 * 60 * 60 * 24));

    return {
      periodInDays: Math.max(0, periodDiff),
      ovulationInDays: Math.max(0, ovulationDiff),
    };
  }, [predictions]);

  // ✅ Données pour la timeline
  const timeline = useMemo(() => {
    if (!summary?.lastRealCycle || !fertilityWindow || !predictions || predictions.length === 0) {
      return [];
    }

    const lastCycle = summary.lastRealCycle;
    const nextPrediction = predictions[0];

    // Dates du dernier cycle
    const periodStart = new Date(lastCycle.startDate);
    const periodEnd = new Date(lastCycle.endDate);

    // Fenêtre de fertilité
    const fertStart = new Date(fertilityWindow.fertileWindow.start);
    const fertEnd = new Date(fertilityWindow.fertileWindow.end);
    const ovulation = new Date(fertilityWindow.ovulationDay);

    // Calcul du PMS (environ 3-4 jours avant la prochaine période)
    const nextPeriodStart = new Date(nextPrediction.predictedStartDate);
    const pmsStart = new Date(nextPeriodStart);
    pmsStart.setDate(pmsStart.getDate() - 4);
    const pmsEnd = new Date(nextPeriodStart);
    pmsEnd.setDate(pmsEnd.getDate() - 1);

    // Calcul de la durée des règles
    const periodDuration = Math.ceil((periodEnd - periodStart) / (1000 * 60 * 60 * 24)) + 1;

    const formatRange = (start, end) => {
      if (start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth()) {
        const month = new Intl.DateTimeFormat(locale, { month: "long" }).format(start);
        const d1 = new Intl.DateTimeFormat(locale, { day: "2-digit" }).format(start);
        const d2 = new Intl.DateTimeFormat(locale, { day: "2-digit" }).format(end);
        return `${d1} – ${d2} ${month}`;
      }
      const fmt1 = new Intl.DateTimeFormat(locale, { day: "2-digit", month: "long" }).format(start);
      const fmt2 = new Intl.DateTimeFormat(locale, { day: "2-digit", month: "long" }).format(end);
      return `${fmt1} – ${fmt2}`;
    };

    const fmtMonthDay = (d) =>
      new Intl.DateTimeFormat(locale, { month: "long", day: "2-digit" }).format(d);

    return [
      {
        type: "period",
        title: t("cycle.period"),
        dateRange: formatRange(periodStart, periodEnd),
        rightNote: t("cycle.periodDurationRange", { range: `${periodDuration}` }),
      },
      {
        type: "fertility",
        title: t("cycle.fertilityWindow"),
        dateRange: formatRange(fertStart, fertEnd),
        rightNote: t("cycle.ovulationDate", { date: fmtMonthDay(ovulation) }),
      },
      {
        type: "pms",
        title: t("cycle.pms"),
        dateRange: formatRange(pmsStart, pmsEnd),
        rightNote: fmtMonthDay(nextPeriodStart),
      },
    ];
  }, [summary, fertilityWindow, predictions, locale, t]);

  if (isLoading || showInitialLoader) {
    return (
      <div className="cyc-wrap" dir={lang.startsWith("ar") ? "rtl" : "ltr"}>
        <div className="cyc-loading">
          <div className="cyc-spinner" aria-label={t("cycle.loading") || "Chargement..."} />
          <span>{t("cycle.loading") || "Chargement..."}</span>
        </div>
      </div>
    );
  }

  // ✅ État d'erreur
  if (error) {
    return (
      <div className="cyc-wrap" dir={lang.startsWith("ar") ? "rtl" : "ltr"}>
        <div className="cyc-error">
          {t("cycle.error") || "Erreur lors du chargement des données"}
        </div>
      </div>
    );
  }

  // ✅ Pas de données
  if (!summary?.lastRealCycle) {
    return (
      <div className="cyc-wrap" dir={lang.startsWith("ar") ? "rtl" : "ltr"}>
        <div className="cyc-empty">
          {t("cycle.noCycleData") || "Aucune donnée de cycle disponible. Commencez par enregistrer votre premier cycle."}
        </div>
      </div>
    );
  }

  return (
    <div className="cyc-wrap" dir={lang.startsWith("ar") ? "rtl" : "ltr"}>
      {/* Top notification */}
      <section className="cyc-top">
        <div className="cyc-top__badge" aria-hidden>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 15V22" stroke="#F783BC" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9 19H15" stroke="#F783BC" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
            <path
              d="M12 15C15.3137 15 18 12.3137 18 9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9C6 12.3137 8.68629 15 12 15Z"
              stroke="#F783BC"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <div className="cyc-top__text">
          <div className="cyc-top__title">
            {periodInDays != null ? (
              <Trans
                i18nKey="cycle.periodExpectedIn"
                values={{ count: periodInDays }}
                components={{ bold: <span className="cyc-bold" /> }}
              />
            ) : (
              <span className="cyc-bold">--</span>
            )}
          </div>

          <div className="cyc-top__sub">
            {ovulationInDays != null ? (
              <Trans
                i18nKey="cycle.nextOvulationIn"
                values={{ count: ovulationInDays }}
                components={{ bold: <span className="cyc-bold" /> }}
              />
            ) : (
              <span className="cyc-bold">--</span>
            )}
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="cyc-card cyc-card--timeline">
        <div className="cyc-card__head">
          <h3 className="cyc-card__title">{t("cycle.cycleTimelines")}</h3>
        </div>

        <div className="cyc-timeline">
          {timeline.map((item, idx) => (
            <div className="cyc-timeline__item" key={`${item.type}-${idx}`}>
              <div className="cyc-timeline__rail" aria-hidden>
                <span className={`cyc-timeline__dot ${idx === 0 ? "is-active" : ""}`} />
              </div>

              <div className="cyc-timeline__content">
                <div className="cyc-timeline__date">{item.dateRange}</div>

                <div className="cyc-row">
                  <div className="cyc-row__left">
                    <TimelineIcon type={item.type} />
                    <div className="cyc-row__texts">
                      <div className="cyc-row__label">{item.title}</div>
                    </div>
                  </div>
                  <div className="cyc-row__right">{item.rightNote}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
